import React, { useEffect, useState } from "react";
import { Stack, Divider, IconButton, Typography } from "@mui/material";
import { Print, Facebook, Twitter, LinkedIn } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import clinicService from "../../services/clinic.service";
import ArticleViewer from "./subcomponents/ArticleViewer";
import "../reputation/reputation.css";
import "./welcome.css";

function Articles() {
  const { clinicId, articleId } = useParams();

  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const shareUrl = window.location.href;

  useEffect(() => {
    if (!clinicId || !articleId) return;

    setLoading(true);
    setNotFound(false);

    clinicService
      .getArticle(clinicId, articleId)
      .then((res) => {
        if (res.data) {
          setArticle(res.data);
        } else {
          setNotFound(true);
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log("Failed to load article", err);
        setNotFound(true);
      })
      .finally(() => setLoading(false));
  }, [clinicId, articleId]);

  const handlePrint = () => window.print();

  if (loading) {
    return (
      <div className="welcome-stack">
        <section className="rep-panel" style={{ display: "grid", placeItems: "center", padding: "3rem" }}>
          <div className="rep-spinner" />
        </section>
      </div>
    );
  }

  if (notFound || !article) {
    return (
      <div className="welcome-stack">
        <section className="rep-panel">
          <p className="rep-kicker">Article</p>
          <h2 className="rep-title">Article not found</h2>
          <p className="rep-copy" style={{ marginBottom: 0 }}>
            The article you are looking for is no longer available.
          </p>
        </section>
      </div>
    );
  }

  const shareTitle = article.title || "Article";

  return (
    <div className="welcome-stack">
      <section className="rep-panel">
        <p className="rep-kicker">Article</p>
        <h2 className="rep-title">{article.title}</h2>

        <Divider sx={{ my: 2.5 }} />

        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          justifyContent="flex-end"
          flexWrap="wrap"
        >
            <Typography variant="caption" sx={{ fontWeight: 700, mr: 0.5 }}>
              Share:
            </Typography>
            <IconButton
              component="a"
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Share on Facebook"
              size="small"
            >
              <Facebook fontSize="small" />
            </IconButton>
            <IconButton
              component="a"
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Share on Twitter"
              size="small"
            >
              <Twitter fontSize="small" />
            </IconButton>
            <IconButton
              component="a"
              href={`https://www.linkedin.com/shareArticle?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareTitle)}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Share on LinkedIn"
              size="small"
            >
              <LinkedIn fontSize="small" />
            </IconButton>
            <IconButton onClick={handlePrint} aria-label="Print article" size="small">
              <Print fontSize="small" />
            </IconButton>
        </Stack>
      </section>

      <section className="rep-panel">
        <ArticleViewer content={article.content} />
      </section>
    </div>
  );
}

export default Articles;
